"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductPrice = void 0;
/**
 * Function search product price by list of attributes
 * @kind function
 */
const getProductPrice = (prices, productId, searchAttributes) => {
    const matchedPrices = [];
    let result;
    if (searchAttributes.length === 0) {
        throw new Error('@merchx/helpers: Function getProductPrice - search attributes should be defined!');
    }
    if (!productId) {
        throw new Error('@merchx/helpers: Function getProductPrice - product ID should be defined!');
    }
    const productPrices = prices.filter((item) => item.productId === productId);
    productPrices.forEach((price) => {
        let allAttributesMatched = true;
        for (const searchAttribute of searchAttributes) {
            const matchedAttribute = price.attributes.find((item) => item.attribute === searchAttribute.attribute && item.value === searchAttribute.value);
            allAttributesMatched = allAttributesMatched && matchedAttribute !== undefined;
        }
        if (allAttributesMatched) {
            matchedPrices.push(price);
        }
    });
    if (matchedPrices.length === 1) {
        result = matchedPrices[0];
    }
    return result;
};
exports.getProductPrice = getProductPrice;
//# sourceMappingURL=getProductPrice.js.map